import { render, staticRenderFns } from "./deleteShopCommunity.vue?vue&type=template&id=4e6116aa"
import script from "./deleteShopCommunity.vue?vue&type=script&lang=js"
export * from "./deleteShopCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports